import type {
  HistorialDePagosModalProps,
  UseHistorialDePagosModalReturn,
} from "./types";

export const useHistorialDePagosModal = ({
  setMostrarHistorial,
}: HistorialDePagosModalProps): UseHistorialDePagosModalReturn => {
  const handleClose = () => {
    setMostrarHistorial(false);
  };

  return {
    handleClose,
  };
};
